import { Link, useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { LEGAL, SHOWROOM, waLink } from "../lib/api";

export default function Footer() {
  const { t } = useLang();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const year = new Date().getFullYear();

  return (
    <footer className="bg-blu text-white mt-0" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-4">
            <p className="eyebrow !text-white/50 mb-4">{t("footer.showroom")}</p>
            <p className="font-display text-2xl leading-snug">{SHOWROOM.address}</p>
            <p className="mt-6 eyebrow !text-white/50 mb-4">{t("footer.legal")}</p>
            <p className="font-display text-2xl leading-snug">{LEGAL.address}</p>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow !text-white/50 mb-4">{t("nav.contact")}</p>
            <a href={waLink("Buongiorno, vorrei delle informazioni.")} target="_blank" rel="noopener noreferrer" className="font-display text-3xl hover:text-rosso transition-colors" data-testid="footer-whatsapp">
              +39 350 937 4737
            </a>
            <p className="mt-2 text-white/50 text-sm">WhatsApp</p>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow !text-white/50 mb-4">{t("footer.data")}</p>
            <ul className="font-mono text-xs leading-6 text-white/70 space-y-0.5">
              <li>LATUAUTONLINE DI CARNOVALE BRUNO</li>
              <li>Ditta Individuale</li>
              <li>P.IVA 10042090968</li>
              <li>CF CRNBRN88P27F205G</li>
              <li>REA 2500949</li>
            </ul>
          </div>
        </div>

        <h2 className="font-display font-medium leading-none tracking-[-0.02em] text-[13.5vw] md:text-[11vw] text-white/90 mt-14 select-none">
          LATUAUTONLINE
        </h2>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-8 font-mono text-[11px] text-white/40">
          <span>© {year} LATUAUTONLINE DI CARNOVALE BRUNO</span>
          <Link to="/admin" className="hover:text-white/70 transition-colors" data-testid="footer-admin-link">
            {t("nav.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
